export default __webpack_public_path__ + "static/media/stop.79a0a869.svg";